import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.get-own-property-names.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Empty } from 'ant-design-vue';
import { updateIsReadFlowableRecord, queryMessageFlowableRecordById } from '@/api/dashboard/systemnotifi.js';
import { queryIsDelayDocument } from '@/api/notice/documentApi.js';
import _, { slice, split } from 'lodash';
export default {
  props: {
    allList: {
      type: [],
      default: ''
    },
    allList1: {
      type: [],
      default: ''
    },
    showLoading2: {
      type: Boolean
    },
    showLoading3: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      gwDot: false,
      ggDot: false,
      tzDot: false,
      loadings: false,
      loadings1: false,
      // showLoading: false,
      // showLoading1: false,
      typeIndex: '',
      menuIndex: 1,
      afficheList: [],
      myIndex: 0,
      applyList: [],
      serviceList: [],
      systemList: [],
      tzggList: [],
      zxgwList: [],
      xttzList: [],
      baoxiuDot: false,
      baoxiaoDot: false
    };
  },
  mounted: function mounted() {
    this.qq();
    if (sessionStorage.getItem('needMenuIndex')) {
      this.menuIndex = sessionStorage.getItem('needMenuIndex');
    }
  },
  methods: {
    /**
     * 跳转至报销查看
     */
    toReimbursementClick: function toReimbursementClick(row) {
      if (row.cateId === 1) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/travelApproval',
          query: {
            fillId: row.id,
            path: 'homepage',
            type: 3
          }
        });
      } else if (row.cateId === 2) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/expenseApproval',
          query: {
            fillId: row.id,
            path: 'homepage',
            type: 3
          }
        });
      }
    },
    /**
     * 跳转至报修查看
     */
    toRepairsClick: function toRepairsClick(row) {
      this.$router.push({
        path: '/reimburseRepairs/repairs/repairsDetail',
        query: {
          id: row.id,
          mode: 'view',
          backTo: 'homepage',
          repairsStatus: row.repairsStatus
        }
      });
    },
    baoxiao: function baoxiao(data) {
      this.applyList = data;
      var applyList = JSON.parse(localStorage.getItem('applyList'));
      this.reimburseCompareArray(applyList, this.applyList);
    },
    baoxiu: function baoxiu(data) {
      this.serviceList = data;
      var serviceList = JSON.parse(localStorage.getItem('serviceList'));
      this.repairsCompareArray(serviceList, this.serviceList);
    },
    refresh: function refresh(data) {
      this.tzggList = data;
      var tzggList = JSON.parse(localStorage.getItem('tzggList'));
      this.tzggCompareArray(tzggList, this.tzggList);
    },
    refresh1: function refresh1(data) {
      this.zxgwList = data;
      var zxgwList = JSON.parse(localStorage.getItem('zxgwList'));
      this.zxgwCompareArray(zxgwList, this.zxgwList);
    },
    refresh2: function refresh2(data) {
      this.xttzList = data;
      var xttzList = JSON.parse(localStorage.getItem('xttzList'));
      this.xttzCompareArray(xttzList, this.xttzList);
    },
    repairsCompareArray: function repairsCompareArray(a1, a2) {
      if (this.compareArray(a1, a2)) {
        this.baoxiuDot = false;
      } else {
        this.baoxiuDot = true;
      }
      this.serviceList = a2;
      localStorage.setItem('serviceList', JSON.stringify(a2));
    },
    reimburseCompareArray: function reimburseCompareArray(a1, a2) {
      if (this.compareArray(a1, a2)) {
        this.baoxiaoDot = false;
      } else {
        this.baoxiaoDot = true;
      }
      this.applyList = a2;
      localStorage.setItem('applyList', JSON.stringify(a2));
    },
    //系统通知
    xttzCompareArray: function xttzCompareArray(a1, a2) {
      var list = _.filter(a2, function (o) {
        return o.status == 0 || o.auditStatus == null;
      });
      if (list.length != 0) {
        this.tzDot = true;
      } else {
        this.tzDot = false;
      }
      this.xttzList = a2;
      localStorage.setItem('xttzList', JSON.stringify(a2));
    },
    //最新公文
    zxgwCompareArray: function zxgwCompareArray(a1, a2) {
      var childrenList = _.filter(a2, function (o) {
        return o.status == 0;
      });
      if (childrenList.length != 0) {
        this.gwDot = true;
      } else {
        this.gwDot = false;
      }
      this.zxgwList = a2;
      localStorage.setItem('zxgwList', JSON.stringify(a2));
    },
    //通知公告
    tzggCompareArray: function tzggCompareArray(a1, a2) {
      var newList = _.filter(a2, function (o) {
        return o.viewStatus == 0;
      });
      if (newList.length != 0) {
        this.ggDot = true;
      } else {
        this.ggDot = false;
      }
      this.tzggList = a2;
      localStorage.setItem('tzggList', JSON.stringify(a2));
    },
    /**
     * 判断两个数组是否相同
     */
    compareArray: function compareArray(a1, a2) {
      if (a1 === a2) return true;
      if (!a1 && a2 || a1 && !a2) {
        return false;
      }
      if (a1.length != a2.length) {
        return false;
      }
      if (toString.call(a1) == '[object Array]' || toString.call(a2) == '[object Array]') {
        for (var i = 0, n = a2.length; i < n; i++) {
          var propsA = Object.getOwnPropertyNames(a1[i]),
            propsB = Object.getOwnPropertyNames(a2[i]);
          for (var a = 0; a < propsA.length; a++) {
            if (a1[i][propsA[a]] !== a2[i][propsB[a]]) {
              return false;
            }
          }
        }
      }
      return true;
    },
    /**
     *跳转至查看公文
     */
    toView: function toView(items) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, req;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return queryIsDelayDocument({
                docId: items.docId
              });
            case 1:
              res = _context.v;
              if (!(res.data.data === 1)) {
                _context.n = 2;
                break;
              }
              _this.$message.error('此公文审核未通过，无法进行查看！');
              return _context.a(2);
            case 2:
              req = {
                id: items.docId
              };
              localStorage.removeItem('needData');
              localStorage.setItem('needData', JSON.stringify(req));
              _this.$router.push({
                path: '/dashboard/workDocSendView',
                query: {
                  data: req,
                  backto: 'put',
                  look: 'editNewDocumentState'
                }
              });
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     *跳转至查看通知公告
     */
    toView1: function toView1(items) {
      var req = {
        id: items.id,
        type: 2,
        look: 'updateWorkbench'
      };
      this.$router.push({
        path: '/dashboard/workNoticeAdd',
        query: {
          id: items.id,
          type: 2,
          look: 'updateWorkbench'
        }
      });
    },
    /**
     * 初核跳转
     */
    firstTrial: function firstTrial(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'firstTrial',
          data: req
        }
      });
    },
    /**
     * 复核跳转
     */
    reCheck: function reCheck(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'reCheck',
          data: req
        }
      });
    },
    /**
     * 会签跳转
     */
    groupSign: function groupSign(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'groupSign',
          data: req
        }
      });
    },
    /**
     * 签发跳转
     */
    signIssue: function signIssue(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'signIssue',
          data: req
        }
      });
    },
    /**
     * 校对跳转
     */
    proofread: function proofread(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'proofread',
          data: req
        }
      });
    },
    /**
     * 打印跳转
     */
    printClick: function printClick(row) {
      var req = {
        id: row.fileId,
        auditId: row.bizId,
        docStatus: row.fillStatus,
        tempId: row.tempId,
        path: 'system'
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          data: req,
          mode: 'print'
        }
      });
    },
    /**
     *跳转至查看系统通知
     */
    toView2: function toView2(items) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, req, _req, _req2, _req3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(items.noticeType == 1)) {
                _context2.n = 1;
                break;
              }
              //通知
              if (items.auditStatus == null) {
                _this2.$router.push({
                  path: '/docNotice/notice/auditNotice',
                  query: {
                    id: items.fileId,
                    type: 2,
                    path: 'system'
                  }
                });
              } else {
                _this2.$router.push({
                  path: '/dashboard/workNoticeAdd',
                  query: {
                    id: items.fileId,
                    type: 2,
                    msgId: items.msgId,
                    noticeType: items.noticeType,
                    look: 'editSystemNoticeState'
                  }
                });
              }
              _context2.n = 5;
              break;
            case 1:
              if (!(items.noticeType == 2)) {
                _context2.n = 4;
                break;
              }
              _context2.n = 2;
              return queryIsDelayDocument({
                docId: items.fileId
              });
            case 2:
              res = _context2.v;
              if (!(res.data.data === 1)) {
                _context2.n = 3;
                break;
              }
              _this2.$message.error('此公文审核未通过，无法进行查看！');
              return _context2.a(2);
            case 3:
              // 公文流转
              if (items.msgType == 2 && items.auditStatus == null) {
                if ((items.tempId === 1 || items.tempId === 2) && items.auditStep === 1 && items.auditStatus !== 1 && items.auditStatus !== 0) {
                  _this2.firstTrial(items);
                } else if (items.tempId === 2 && items.auditStep === 2 && items.auditStatus !== 1 && items.auditStatus !== 0) {
                  _this2.reCheck(items);
                } else if (items.tempId === 2 && items.auditStep === 3 && items.auditStatus !== 1 && items.auditStatus !== 0 && items.result == -1) {
                  _this2.groupSign(items);
                } else if (items.tempId === 1 && items.auditStep === 2 && items.auditStatus !== 1 && items.auditStatus !== 0) {
                  _this2.signIssue(items);
                } else if (items.tempId === 2 && items.auditStep === 4 && items.auditStatus !== 1 && items.auditStatus !== 0) {
                  _this2.signIssue(items);
                } else if (items.tempId === 2 && items.auditStep === 5 && items.auditStatus !== 1 && items.auditStatus !== 0) {
                  _this2.proofread(items);
                } else if (items.tempId === 2 && items.auditStep === 6 && items.auditStatus !== 1 && items.auditStatus !== 0) {
                  _this2.printClick(items);
                } else if (items.tempId === 4 && items.auditStatus !== 1 && items.auditStatus !== 0) {
                  req = {
                    id: items.fileId,
                    auditId: items.bizId,
                    isEmergent: items.isEmergent,
                    tempId: items.tempId,
                    docStatus: items.fillStatus,
                    auditStep: items.auditStep
                  };
                  localStorage.removeItem('needData');
                  localStorage.setItem('needData', JSON.stringify(req));
                  _this2.$router.push({
                    path: '/docNotice/doc/docReview',
                    query: {
                      mode: 'reView',
                      data: req
                    }
                  });
                } else {
                  _req = {
                    id: items.fileId,
                    auditId: items.bizId,
                    tempId: items.tempId,
                    docStatus: items.fillStatus,
                    isEmergent: items.isEmergent
                  };
                  localStorage.removeItem('needData');
                  localStorage.setItem('needData', JSON.stringify(_req));
                  _this2.$router.push({
                    path: '/dashboard/workDocSendView',
                    query: {
                      data: _req,
                      backto: 'deal'
                    }
                  });
                }
              } else {
                if (items.msgType == 1) {
                  _req2 = {
                    id: items.fileId,
                    auditId: items.bizId,
                    msgId: items.msgId,
                    type: items.noticeType,
                    look: 'editSystemNoticeState'
                  };
                  localStorage.removeItem('needData');
                  localStorage.setItem('needData', JSON.stringify(_req2));
                  _this2.$router.push({
                    path: '/dashboard/workDocSendView',
                    query: {
                      data: _req2,
                      backto: 'put'
                    }
                  });
                } else {
                  _req3 = {
                    id: items.fileId,
                    auditId: items.bizId,
                    tempId: items.tempId,
                    docStatus: items.fillStatus
                  };
                  localStorage.removeItem('needData');
                  localStorage.setItem('needData', JSON.stringify(_req3));
                  _this2.$router.push({
                    path: '/dashboard/workDocSendView',
                    query: {
                      data: _req3,
                      backto: 'deal'
                    }
                  });
                }
              }
              _context2.n = 5;
              break;
            case 4:
              if (items.noticeType == 3) {
                // 3报销
                if (items.auditStatus == null) {
                  //进入审核页面
                  if (items.cateId === 1) {
                    _this2.$router.push({
                      path: '/reimburseRepairs/myReimburse/travelApproval',
                      query: {
                        fillId: items.fileId,
                        type: 2
                      }
                    });
                  } else if (items.cateId === 2) {
                    _this2.$router.push({
                      path: '/reimburseRepairs/myReimburse/expenseApproval',
                      query: {
                        fillId: items.fileId,
                        type: 2
                      }
                    });
                  }
                } else {
                  //进入查看详情
                  if (items.cateId === 1) {
                    _this2.$router.push({
                      path: '/reimburseRepairs/myReimburse/travelApproval',
                      query: {
                        fillId: items.fileId,
                        type: 1
                      }
                    });
                  } else if (items.cateId === 2) {
                    _this2.$router.push({
                      path: '/reimburseRepairs/myReimburse/expenseApproval',
                      query: {
                        fillId: items.fileId,
                        type: 1
                      }
                    });
                  }
                }
              } else if (items.noticeType == 4) {
                // 4 报修
                if (items.auditStatus == null) {
                  //进入审核页面
                  if (items.fillStatus == 1 || items.fillStatus == 2) {
                    _this2.$router.push({
                      path: '/reimburseRepairs/repairs/repairsDetail',
                      query: {
                        id: items.fileId,
                        mode: 'accept',
                        backTo: 'system',
                        repairsStatus: items.fillStatus
                      }
                    });
                  } else if (items.fillStatus == 3) {
                    _this2.$router.push({
                      path: '/reimburseRepairs/repairs/repairsDetail',
                      query: {
                        id: items.fileId,
                        mode: 'order',
                        backTo: 'system',
                        repairsStatus: items.fillStatus
                      }
                    });
                  } else if (items.fillStatus == 7) {
                    _this2.$router.push({
                      path: '/reimburseRepairs/repairs/repairsDetail',
                      query: {
                        id: items.fileId,
                        mode: 'evaluation',
                        backTo: 'system',
                        repairsStatus: items.fillStatus
                      }
                    });
                  }
                } else {
                  //进入查看详情
                  _this2.$router.push({
                    path: '/reimburseRepairs/repairs/repairsDetail',
                    query: {
                      id: items.fileId,
                      mode: 'view',
                      backTo: 'system',
                      repairsStatus: items.fillStatus
                    }
                  });
                }
              } else if (items.noticeType == 5) {
                // 5 表单审批
                if (items.auditStatus == null) {
                  //进入审核页面
                  queryMessageFlowableRecordById(items.msgId).then(function (res) {
                    _this2.$router.push({
                      path: '/formReview/reviewCenter/auditProcess',
                      query: {
                        procInsId: items.bizId,
                        taskId: res.data.data.taskId,
                        path: 'waitMeApplication'
                      }
                    });
                  });
                } else {
                  //进入查看详情
                  if (items.msgType == 1) {
                    updateIsReadFlowableRecord(items.msgId).then(function (res) {
                      _this2.$router.push({
                        path: '/formReview/reviewCenter/viewProcess',
                        query: {
                          procInsId: items.bizId
                        }
                      });
                    });
                  } else if (items.msgType == 2) {
                    _this2.$router.push({
                      path: '/formReview/reviewCenter/viewProcess',
                      query: {
                        procInsId: items.bizId
                      }
                    });
                  }
                }
              }
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handleLoading: function handleLoading() {
      var _this3 = this;
      this.loadings = true;
      if (this.menuIndex == 0) {
        this.$parent.newDocument();
      } else if (this.menuIndex == 1) {
        this.$parent.workbench();
      } else if (this.menuIndex == 2) {
        this.$parent.systemNotice();
      }
      setTimeout(function () {
        _this3.loadings = false;
      }, 1000);
    },
    handleLoading1: function handleLoading1() {
      var _this4 = this;
      this.loadings1 = true;
      if (this.myIndex == 0) {
        this.$parent.getQueryRepair();
      } else {
        this.$parent.getQueryReimburse();
      }
      setTimeout(function () {
        _this4.loadings1 = false;
      }, 1000);
    },
    qq: function qq() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (_this5.allList) {
                _this5.allList.forEach(function (item) {
                  _this5.typeIndex = item.typeIndex;
                  _this5.newList = item.newList;
                  _this5.afficheList = item.afficheList;
                  _this5.systemList = item.systemList;
                });
              }
              if (_this5.allList1) {
                _this5.allList1.forEach(function (item) {
                  if (item.typeIndex == 1) {
                    _this5.typeIndex = item.typeIndex;
                    _this5.applyList = item.applyList;
                    _this5.serviceList = item.serviceList;
                  }
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    changeMenuIndex: function changeMenuIndex(e) {
      this.menuIndex = e;
      sessionStorage.setItem('needMenuIndex', e);
      if (e == 0) {
        this.$parent.newDocument();
      } else if (e == 1) {
        this.$parent.workbench();
      } else if (e == 2) {
        this.$parent.systemNotice();
      }
    },
    toNewdocment: function toNewdocment() {
      if (this.menuIndex == 0) {
        this.$router.push('/dashboard/newdocment');
      } else if (this.menuIndex == 1) {
        this.$router.push('/dashboard/announcements');
      } else {
        this.$router.push('/dashboard/systemnotifi');
      }
    },
    /**
     * 我的报修和我的报销切换
     */
    changeMyIndex: function changeMyIndex(e) {
      this.myIndex = e;
      if (e == 0) {
        this.$parent.getQueryRepair();
      } else {
        this.$parent.getQueryReimburse();
      }
    },
    /**
     * 跳转至报修界面
     */
    toRepair: function toRepair() {
      this.$router.push('/dashboard/repair');
    },
    /**
     * 跳转至系统通知界面
     */
    toSystemnotifi: function toSystemnotifi() {
      this.$router.push('/dashboard/systemnotifi');
    }
  }
};